export enum ChecklistToggleRow {
  CloseDiscounts = 'CloseDiscounts',
  // ConfirmClose
  CloseExpenses = 'CloseExpenses',
  ForecastCurves = 'ForecastCurves',
  ForecastMethodology = 'ForecastMethodology',
  // ConfirmForecast
  ForecastTimeline = 'ForecastTimeline',
  // GatherDocuments
  GatherContracts = 'GatherContracts',
  GatherEstimates = 'GatherEstimates',
  GatherInvoices = 'GatherInvoices',
  GatherPatients = 'GatherPatients',
}

export type ChecklistToggleState = Record<ChecklistToggleRow, boolean>;
